const Key = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    version="1.1"
    viewBox="0 0 300 300"
    xmlSpace="preserve"
  >
    <path d="M287.305 243.005a7.478 7.478 0 00-2.227-4.747L172.835 126.015c4.416-10.403 6.747-21.669 6.747-33.312 0-22.754-8.875-44.163-24.938-60.266C138.558 16.366 117.164 7.5 94.397 7.5c-22.778 0-44.135 8.869-60.247 24.95C.907 65.675.9 119.716 34.145 152.938c16.111 16.115 37.475 24.99 60.241 24.99a85.029 85.029 0 0033.312-6.772l36.874 36.902a7.714 7.714 0 005.74 2.248l20.095-.705-.656 20.145c-.062 2.125.705 4.193 2.245 5.706a7.572 7.572 0 005.685 2.248l20.169-.689-.724 20.123a7.85 7.85 0 002.238 5.712c1.534 1.512 3.321 2.325 5.74 2.251l20.119-.684-.674 20.126c-.118 2.232.822 4.379 2.418 5.903 1.472 1.339 3.309 2.06 5.245 2.06.278 0 .563-.012.847-.037l30.851-3.426c4.169-.455 7.205-4.175 6.847-8.353l-3.452-37.681zM84.106 82.415c-9.476 9.466-24.796 9.466-34.252 0-9.47-9.469-9.47-24.786 0-34.246 9.456-9.46 24.771-9.469 34.252-.003 9.457 9.459 9.451 24.786 0 34.249zm176.864 163.16c-1.126 1.126-2.635 1.688-4.101 1.688s-2.976-.563-4.101-1.688l-95.501-95.529a81.5 81.5 0 007.273-9.058l96.429 96.41c2.252 2.252 2.252 5.926.001 8.177z" />
  </svg>
);

export default Key;
